import { createApp } from 'vue'
import FormInputCprField from './FormInputCprField'

const el = '.kb-component--form-input-cpr-field'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((FormInputCprFieldDOM) => {
            const props = {
                type: FormInputCprFieldDOM.dataset.type,
                tooltipText: FormInputCprFieldDOM.dataset.tooltiptext,
                errorMessageLabel:
                    FormInputCprFieldDOM.dataset.errormessagelabel,
                helpMessageLabel: FormInputCprFieldDOM.dataset.helpmessagelabel,
                placeholder: FormInputCprFieldDOM.dataset.placeholder,
                label: FormInputCprFieldDOM.dataset.label,
                isRequired: !!(
                    FormInputCprFieldDOM.dataset.isrequired === 'true'
                ),
                fieldName: FormInputCprFieldDOM.dataset.fieldname
            }
            const component = createApp(FormInputCprField, props).use(Store)
            component.mount(FormInputCprFieldDOM)
        })
    }
}
